import produce from 'immer';
import Queue from 'helpers/queue';

const queueMarkAsRead = new Queue();

export const baseNotification = () => {
  return {
    isFetched: false,
    isFetching: false,
    isLoadMore: false,
    isMarkingAllAsRead: false,
    loadMoreMode: false,
    queueMarkAsRead: queueMarkAsRead.queue,

    notificationsUnread: [],
    notificationsRead: [],
    count: 0,
    isLast: false,

    errorGetNotification: null,
    errorUpdate: null,
  };
};

// Mark each notification
export const fetchMarkAsRead = (actions, state) => {
  const listId = (actions.notifications || []).split(',');
  listId.forEach((id) => {
    queueMarkAsRead.pushToQueue(id);
  });
  return produce(state, (draft) => {
    draft.queueMarkAsRead = queueMarkAsRead.queue;
  });
};

export const fetchMarkAsReadSuccess = (actions, state) => {
  const listId = (actions.notifications || []).split(',');
  listId.forEach((id) => {
    queueMarkAsRead.removeFromQueue(id);
  });
  return produce(state, (draft) => {
    draft.queueMarkAsRead = queueMarkAsRead.queue;
  });
};

export const fetchMarkAsReadFailed = (actions, state) => {
  const listId = (actions.notifications || []).split(',');
  listId.forEach((id) => {
    queueMarkAsRead.removeFromQueue(id);
  });
  return produce(state, (draft) => {
    draft.queueMarkAsRead = queueMarkAsRead.queue;
  });
};

// Mark all request
export const fetchMarkAllAsRead = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMarkingAllAsRead = true;
  });
};

export const fetchMarkAllAsReadSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMarkingAllAsRead = false;
  });
};

export const fetchMarkAllAsReadFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMarkingAllAsRead = false;
  });
};

// Load more notification
export const fetchLoadMoreNotification = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadMore = true;
  });
};

export const fetchLoadMoreNotificationSuccess = (actions, state) => {
  const { isUnread, isLast, notifications } = actions;
  return produce(state, (draft) => {
    draft.isLoadMore = false;
    draft.loadMoreMode = true;
    draft.isLast = isLast;
    if (isUnread) {
      draft.notificationsUnread = [...draft.notificationsUnread, ...notifications];
    } else {
      draft.notificationsRead = [...draft.notificationsRead, ...notifications];
    }
  });
};

export const fetchLoadMoreNotificationFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadMore = false;
  });
};

// Get Notification
export const fetchNotification = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = true;
  });
};

export const fetchNotificationSuccess = (actions, state) => {
  const { isUnread, notifications, isLast } = actions;
  return produce(state, (draft) => {
    draft.isFetched = true;
    draft.isFetching = false;
    draft.isLast = isLast;
    draft.errorGetNotification = null;
    if (isUnread) {
      draft.notificationsUnread = notifications;
    } else {
      draft.notificationsRead = notifications;
    }
  });
};

export const fetchNotificationFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = false;
    draft.errorGetNotification = actions.error;
  });
};

// Count notification
export const fetchCountNotificationSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.count = actions.count;
  });
};

export const fetchCountNotificationFailed = (actions, state) => {
  return produce(state, (draft) => {});
};
